export const TableTypes = {
  Rectangle: "Rectangle",
  Oval: "Oval",
};
